import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Translation } from 'react-i18next';
import classNames from 'classnames';
import { getAuthState, getTenantState } from '../store/selectors';
import {
  getCurrentUserId,
  saveNewTenantForUser,
  saveResults,
  resetUserFavorites,
} from '../store/actions';
import CloseIcon from './utility/CloseIcon';
import WarningIcon from './utility/WarningIcon';

class UpdateDataBanner extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
    };
  }

  setShowModal = () => {
    this.setState((prevState) => ({ showModal: !prevState.showModal }));
  };

  updateData = async () => {
    await this.recalculate();
  };

  recalculate = async () => {
    const userId = await this.props.getCurrentUserId(this.props.auth.jwtToken);

    await this.props.resetUserFavorites(userId);

    const scores = this.props.userData.user;
    const score = {
      riasecValues: {
        r: scores.gameRChoices,
        i: scores.gameIChoices,
        a: scores.gameAChoices,
        s: scores.gameSChoices,
        e: scores.gameEChoices,
        c: scores.gameCChoices,
      },
    };

    await this.props.saveResults(score, this.props.auth.jwtToken);

    if (window.location.pathname.includes('career-path/top-3')) {
      window.location.reload(true);
    } else {
      this.props.history.push({
        pathname: `/${this.props.tenant.name.toLowerCase()}/career-path/top-3`,
      });
    }
  };

  modal = (t) => {
    const secondaryColorBar = {
      height: '3px',
      width: '62px',
      backgroundColor: `${this.props.tenant.secondary}`,
      marginTop: '10px',
      marginBottom: '19px',
    };

    return (
      <div
        className={classNames({
          'update-data-modal__transparent-background-modal': true,
          'update-data-modal__display-none': !true,
        })}
        style={{ position: 'fixed' }}
      >
        <div className="update-data-modal__content">
          <CloseIcon
            tenant={this.props.tenant}
            onClickParent={this.setShowModal}
            ariaLabel="Click here to close the out of date career and/or degree information modal"
          />
          <div className="update-data-modal__modal">
            <p className="update-data-modal__modal-header">
              {t('Your me3 data is out of date')}
            </p>
            <div style={secondaryColorBar} />
            <p className="update-data-modal__modal-text">
              {t(
                'Want the most up to date career information and degree offerings? Click the "Update my data" button below.'
              )}
            </p>
            <p className="update-data-modal__modal-header2">
              {t('Updating your data will affect:')}
            </p>
            <ul className="update-data-modal__modal-bullets">
              <li key="update-data-modal1">
                {t('Inactive degrees can no longer be paired with.')}
              </li>
              <li key="update-data-modal2">
                {t('Inactive careers in your top 25 will no longer display.')}
              </li>
              <li key="update-data-modal3">
                {t(
                  'Favorited careers will be refreshed. Out of date favorited careers will no longer display.'
                )}
              </li>
            </ul>
            <p className="update-data-modal__modal-warning">
              {t(
                'This action is strongly recommended for the best user application experience.'
              )}
            </p>
            <div className="update-data-modal__modal-bottom">
              <button
                className="update-data-modal__modal-update-button"
                type="button"
                onClick={async () => this.updateData()}
              >
                {t('Update my data')}
              </button>
              <button
                className="update-data-modal__modal-no-button"
                type="button"
                onClick={() => this.setShowModal()}
              >
                {t('No thanks')}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    return (
      <Translation>
        {(t) => (
          <>
            {this.state.showModal && this.modal(t)}
            <div className="update-data-banner">
              <WarningIcon height="22" width="22" color="#FFFFFF" />
              <p className="update-data-banner__text">
                {t('Your career and/or degree data is out of date')}
              </p>
              <button
                className="update-data-banner__learn-more-button"
                type="button"
                onClick={() => this.setShowModal()}
              >
                {t('Learn More')}
              </button>
            </div>
          </>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = (state) => {
  const tenant = getTenantState(state);
  const auth = getAuthState(state);
  const userData = state.onboarding.userData;

  return { tenant, auth, userData };
};

export default withRouter(
  connect(mapStateToProps, {
    getCurrentUserId,
    saveResults,
    saveNewTenantForUser,
    resetUserFavorites,
  })(UpdateDataBanner)
);
